import React, { useState } from 'react';
import {
  getRehydratableName,
  getClassNameFactory,
  Grid,
  Button,
  Heading,
  SaffronCard,
} from '@dcl/ui';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import { IMoreSupportItem, IMoreSupportProps } from './types';
import { ButtonColor, ButtonKind } from '@dcl/ui/dist/elements/Button';
import { boldTypes, types } from '@dcl/ui/dist/elements/Heading';
import { getGridVariantType } from './utils';
import './MoreSupport.css';

export const MoreSupport: React.FC<IMoreSupportProps> = (props) => {
  const {
    showLessButtonLabel,
    showMoreButtonLabel,
    moreSupportList,
    moreSupportTitle,
    noOfCardsPerRow,
  } = props;
  const getClassName = getClassNameFactory(MoreSupport.displayName);
  const getCardsPerRow = () => {
    if (noOfCardsPerRow > 6 || noOfCardsPerRow === 1) {
      return 3;
    }
    return noOfCardsPerRow > moreSupportList.length
      ? moreSupportList.length
      : noOfCardsPerRow;
  };
  const cardsPerRow = getCardsPerRow();
  const gridEven = getGridVariantType(cardsPerRow);
  const [isExpanded, setIsExpanded] = useState(false);

  const onShowMoreClick = () => {
    setIsExpanded(!isExpanded);
  };

  const hasAdditionalCards = moreSupportList.length > cardsPerRow;

  const getNumberOfCardsToShow = () => {
    if (isExpanded) {
      return moreSupportList.length;
    }
    return gridEven !== 'even-3' ? cardsPerRow : 3;
  };

  return (
    <div
      className={getClassName()}
      data-rehydratable={getRehydratableName(MoreSupport.displayName)}
      {...propsToDataAttributes(props)}
    >
      <Heading
        className={getClassName({ descendantName: 'pageTitle' })}
        type={types.Medium}
        boldType={boldTypes.medium}
      >
        {moreSupportTitle}
      </Heading>

      <div className={getClassName({ descendantName: 'container' })}>
        <Grid variant={gridEven}>
          {moreSupportList
            ?.slice(0, getNumberOfCardsToShow())
            .map(
              ({
                newTab,
                url,
                urlLabel,
                eyebrowText,
                title,
                description,
              }: IMoreSupportItem) => (
                <Grid.Item key={url}>
                  <SaffronCard
                    key={url}
                    eyebrow={eyebrowText}
                    heading={title}
                    description={description}
                    link={url}
                    linkText={urlLabel}
                    newTab={newTab}
                  />
                </Grid.Item>
              )
            )}
        </Grid>
      </div>
      {hasAdditionalCards && (
        <div className={getClassName({ descendantName: 'buttonContainer' })}>
          <Button
            kind={ButtonKind.BUTTON}
            color={ButtonColor.SECONDARY}
            onClick={() => onShowMoreClick()}
          >
            {isExpanded ? showLessButtonLabel : showMoreButtonLabel}
          </Button>
        </div>
      )}
    </div>
  );
};

MoreSupport.displayName = 'MoreSupport';
